import { VoxelCoord } from "@latticexyz/utils";
import { BlockTypeKey } from "../network/constants";
import { Block, NoaBlockType } from "./types";

export const CRAFTING_SIDE = 3;
export const SPAWN_POINT: VoxelCoord = { x: -1543, y: 15, z: -808 };
export const CRAFTING_SIZE = CRAFTING_SIDE * CRAFTING_SIDE;
export const EMPTY_CRAFTING_TABLE = [...new Array(CRAFTING_SIZE)].map(() => -1);
export const MINING_DURATION = 800;
export const FAST_MINING_DURATION = 400;

export const Textures = {
  Grass: "./assets/blocks/4-Grass_block-top.png",
  GrassSide: "./assets/blocks/4-Grass_block-side.png",
  GrassBottom: "./assets/blocks/4-Grass_block-bottom.png",
  Dirt: "./assets/blocks/3-Dirt.png",
  Log: "./assets/blocks/47-Log-1-sides.png",
  LogTop: "./assets/blocks/47-Log-0-top.png",
  Sand: "./assets/blocks/07-Sand.png",
  Glass: "./assets/blocks/11-Glass.png",
  Stone: "./assets/blocks/48-Stone.png",
  Water: "./assets/blocks/10-4-Water.png",
  TransparentWater: "./assets/blocks/10-4-Water.png",
  Cobblestone: "./assets/blocks/1-Cobblestone.png",
  MossyCobblestone: "./assets/blocks/14-Mossy_Cobblestone.png",
  Coal: "./assets/blocks/39-Coal_Ore.png",
  Iron: "./assets/blocks/38-Iron_Ore.png",
  Gold: "./assets/blocks/40-Gold_Ore.png",
  Diamond: "./assets/blocks/49-Diamond_ore.png",
  Leaves: "./assets/blocks/06-Leaves.png",
  Planks: "./assets/blocks/05-Wood_plank.png",
  Crafting: "./assets/blocks/46-Crafting_Table-0-top.png",
  CraftingSide: "./assets/blocks/46-Crafting_Table-1-sides.png",
  CraftingBottom: "./assets/blocks/46-Crafting_Table-2-bottom.png",
  Wool: "./assets/blocks/22-White_Wool.png",
  OrangeWool: "./assets/blocks/23-Orange_Wool.png",
  MagentaWool: "./assets/blocks/24-Magenta_Wool.png",
  LightBlueWool: "./assets/blocks/25-Light_Blue_Wool.png",
  YellowWool: "./assets/blocks/26-Yellow_Wool.png",
  LimeWool: "./assets/blocks/27-Lime_Wool.png",
  PinkWool: "./assets/blocks/28-Pink_Wool.png",
  GrayWool: "./assets/blocks/29-Gray_Wool.png",
  LightGrayWool: "./assets/blocks/30-Light_Gray_Wool.png",
  CyanWool: "./assets/blocks/31-Cyan_Wool.png",
  PurpleWool: "./assets/blocks/32-Purple_Wool.png",
  BlueWool: "./assets/blocks/33-Blue_Wool.png",
  BrownWool: "./assets/blocks/34-Brown_Wool.png",
  GreenWool: "./assets/blocks/35-Green_Wool.png",
  RedWool: "./assets/blocks/36-Red_Wool.png",
  BlackWool: "./assets/blocks/37-Black_Wool.png",
  Sponge: "./assets/blocks/21-Sponge.png",
  Snow: "./assets/blocks/62-Snow_on_grass-0-top.png",
  Clay: "./assets/blocks/64-Clay.png",
  RedFlower: "./assets/blocks/16-Red_flower-cccc.png",
  OrangeFlower: "./assets/blocks/50-Orange_flower.png",
  MagentaFlower: "./assets/blocks/51-Magenta_flower.png",
  LightBlueFlower: "./assets/blocks/52-Light_blue_flower.png",
  LimeFlower: "./assets/blocks/53-lime_flower.png",
  PinkFlower: "./assets/blocks/54-pink_flower.png",
  GrayFlower: "./assets/blocks/55-gray_flower.png",
  LightGrayFlower: "./assets/blocks/56-light_gray_flower.png",
  CyanFlower: "./assets/blocks/57-cyan_flower.png",
  PurpleFlower: "./assets/blocks/58-purple_flower.png",
  BlueFlower: "./assets/blocks/59-blue_flower.png",
  GreenFlower: "./assets/blocks/60-green_flower.png",
  BlackFlower: "./assets/blocks/61-black_flower.png",
  GrassPlant: "./assets/blocks/63-Grass_plant.png",
  Kelp: "./assets/blocks/65-Kelp-2.png",
  Bedrock: "./assets/blocks/44-Obsidian.png",
  Bricks: "./assets/blocks/2-Bricks.png",
};

export const UVWraps: { [key in BlockTypeKey]: string | undefined } = {
  Air: undefined,
  Grass: "./assets/uv-wraps/grass.png",
  Dirt: "./assets/uv-wraps/dirt.png",
  Log: "./assets/uv-wraps/log.png",
  Sand: "./assets/uv-wraps/sand.png",
  Glass: "./assets/uv-wraps/glass.png",
  Stone: "./assets/uv-wraps/stone.png",
  Water: undefined,
  Cobblestone: "./assets/uv-wraps/cobblestone.png",
  Coal: "./assets/uv-wraps/coal.png",
  Crafting: "./assets/uv-wraps/crafting.png",
  Iron: "./assets/uv-wraps/iron.png",
  Gold: "./assets/uv-wraps/gold.png",
  Diamond: "./assets/uv-wraps/diamond.png",
  Leaves: "./assets/uv-wraps/leaves.png",
  Planks: "./assets/uv-wraps/planks.png",
  Wool: "./assets/uv-wraps/wool.png",
  OrangeWool: "./assets/uv-wraps/orange-wool.png",
  MagentaWool: "./assets/uv-wraps/magenta-wool.png",
  LightBlueWool: "./assets/uv-wraps/light-blue-wool.png",
  YellowWool: "./assets/uv-wraps/yellow-wool.png",
  LimeWool: "./assets/uv-wraps/lime-wool.png",
  PinkWool: "./assets/uv-wraps/pink-wool.png",
  GrayWool: "./assets/uv-wraps/gray-wool.png",
  LightGrayWool: "./assets/uv-wraps/light-gray-wool.png",
  CyanWool: "./assets/uv-wraps/cyan-wool.png",
  PurpleWool: "./assets/uv-wraps/purple-wool.png",
  BlueWool: "./assets/uv-wraps/blue-wool.png",
  BrownWool: "./assets/uv-wraps/brown-wool.png",
  GreenWool: "./assets/uv-wraps/green-wool.png",
  RedWool: "./assets/uv-wraps/red-wool.png",
  BlackWool: "./assets/uv-wraps/black-wool.png",
  Sponge: "./assets/uv-wraps/sponge.png",
  Snow: "./assets/uv-wraps/snow.png",
  Clay: "./assets/uv-wraps/clay.png",
  Bedrock: "./assets/uv-wraps/bedrock.png",
  Bricks: "./assets/uv-wraps/bricks.png",
  MossyCobblestone: "./assets/uv-wraps/mossy-cobblestone.png",
  RedFlower: undefined,
  OrangeFlower: undefined,
  MagentaFlower: undefined,
  LightBlueFlower: undefined,
  LimeFlower: undefined,
  PinkFlower: undefined,
  GrayFlower: undefined,
  LightGrayFlower: undefined,
  CyanFlower: undefined,
  PurpleFlower: undefined,
  BlueFlower: undefined,
  GreenFlower: undefined,
  BlackFlower: undefined,
  Kelp: undefined,
  GrassPlant: undefined,
};

export const Blocks: { [key in BlockTypeKey]: Block | undefined } = {
  Air: undefined,
  Grass: { type: NoaBlockType.BLOCK, material: [Textures.Grass, Textures.Dirt, Textures.GrassSide] },
  Dirt: { type: NoaBlockType.BLOCK, material: Textures.Dirt },
  Log: { type: NoaBlockType.BLOCK, material: [Textures.LogTop, Textures.Log] },
  Sand: { type: NoaBlockType.BLOCK, material: Textures.Sand },
  Glass: { type: NoaBlockType.BLOCK, material: Textures.Glass, opaque: true },
  Stone: { type: NoaBlockType.BLOCK, material: Textures.Stone },
  Water: {
    type: NoaBlockType.BLOCK,
    material: [Textures.Water, Textures.TransparentWater, Textures.TransparentWater],
    opaque: false,
    fluid: true,
    solid: false,
  },
  Cobblestone: { type: NoaBlockType.BLOCK, material: Textures.Cobblestone },
  Coal: { type: NoaBlockType.BLOCK, material: Textures.Coal },
  Crafting: {
    type: NoaBlockType.BLOCK,
    material: [Textures.Crafting, Textures.CraftingBottom, Textures.CraftingSide],
  },
  Iron: { type: NoaBlockType.BLOCK, material: Textures.Iron },
  Gold: { type: NoaBlockType.BLOCK, material: Textures.Gold },
  Diamond: { type: NoaBlockType.BLOCK, material: Textures.Diamond },
  Leaves: { type: NoaBlockType.BLOCK, material: Textures.Leaves, opaque: true },
  Planks: { type: NoaBlockType.BLOCK, material: Textures.Planks },
  Wool: { type: NoaBlockType.BLOCK, material: Textures.Wool },
  OrangeWool: { type: NoaBlockType.BLOCK, material: Textures.OrangeWool },
  MagentaWool: { type: NoaBlockType.BLOCK, material: Textures.MagentaWool },
  LightBlueWool: { type: NoaBlockType.BLOCK, material: Textures.LightBlueWool },
  YellowWool: { type: NoaBlockType.BLOCK, material: Textures.YellowWool },
  LimeWool: { type: NoaBlockType.BLOCK, material: Textures.LimeWool },
  PinkWool: { type: NoaBlockType.BLOCK, material: Textures.PinkWool },
  GrayWool: { type: NoaBlockType.BLOCK, material: Textures.GrayWool },
  LightGrayWool: { type: NoaBlockType.BLOCK, material: Textures.LightGrayWool },
  CyanWool: { type: NoaBlockType.BLOCK, material: Textures.CyanWool },
  PurpleWool: { type: NoaBlockType.BLOCK, material: Textures.PurpleWool },
  BlueWool: { type: NoaBlockType.BLOCK, material: Textures.BlueWool },
  BrownWool: { type: NoaBlockType.BLOCK, material: Textures.BrownWool },
  GreenWool: { type: NoaBlockType.BLOCK, material: Textures.GreenWool },
  RedWool: { type: NoaBlockType.BLOCK, material: Textures.RedWool },
  BlackWool: { type: NoaBlockType.BLOCK, material: Textures.BlackWool },
  Sponge: { type: NoaBlockType.BLOCK, material: Textures.Sponge },
  Snow: { type: NoaBlockType.BLOCK, material: Textures.Snow },
  Clay: { type: NoaBlockType.BLOCK, material: Textures.Clay },
  Bedrock: { type: NoaBlockType.BLOCK, material: Textures.Bedrock },
  Bricks: { type: NoaBlockType.BLOCK, material: Textures.Bricks },
  MossyCobblestone: { type: NoaBlockType.BLOCK, material: Textures.MossyCobblestone },
  RedFlower: { type: NoaBlockType.MESH, material: Textures.RedFlower, solid: false, opaque: false },
  OrangeFlower: { type: NoaBlockType.MESH, material: Textures.OrangeFlower, solid: false, opaque: false },
  MagentaFlower: { type: NoaBlockType.MESH, material: Textures.MagentaFlower, solid: false, opaque: false },
  LightBlueFlower: { type: NoaBlockType.MESH, material: Textures.LightBlueFlower, solid: false, opaque: false },
  LimeFlower: { type: NoaBlockType.MESH, material: Textures.LimeFlower, solid: false, opaque: false },
  PinkFlower: { type: NoaBlockType.MESH, material: Textures.PinkFlower, solid: false, opaque: false },
  GrayFlower: { type: NoaBlockType.MESH, material: Textures.GrayFlower, solid: false, opaque: false },
  LightGrayFlower: { type: NoaBlockType.MESH, material: Textures.LightGrayFlower, solid: false, opaque: false },
  CyanFlower: { type: NoaBlockType.MESH, material: Textures.CyanFlower, solid: false, opaque: false },
  PurpleFlower: { type: NoaBlockType.MESH, material: Textures.PurpleFlower, solid: false, opaque: false },
  BlueFlower: { type: NoaBlockType.MESH, material: Textures.BlueFlower, solid: false, opaque: false },
  GreenFlower: { type: NoaBlockType.MESH, material: Textures.GreenFlower, solid: false, opaque: false },
  BlackFlower: { type: NoaBlockType.MESH, material: Textures.BlackFlower, solid: false, opaque: false },
  Kelp: { type: NoaBlockType.MESH, material: Textures.Kelp, solid: false, opaque: false, frames: 2 },
  GrassPlant: { type: NoaBlockType.MESH, material: Textures.GrassPlant, solid: false, opaque: false },
};

export function getBlockIconUrl(blockType: BlockTypeKey): string | undefined {
  const block = Blocks[blockType];
  if (!block) return;
  return Array.isArray(block.material) ? block.material[0] : block.material;
}
